'use client';
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function TermsOfUsePage() {
  return (
    <main style={{ fontFamily: 'Montserrat, sans-serif' }}>
      <Header />

      {/* Hero */}
      <section
        style={{
          backgroundColor: '#003c82',
          padding: '80px 24px 60px',
        }}
      >
        <div style={{ maxWidth: '860px', margin: '0 auto' }}>
          <p style={{ fontSize: '12px', fontWeight: '600', letterSpacing: '0.14em', textTransform: 'uppercase', color: '#6dcff6', marginBottom: '16px' }}>
            Legal
          </p>
          <h1 style={{ fontSize: '42px', fontWeight: '700', color: '#ffffff', margin: 0, lineHeight: 1.15 }}>
            Terms of Use
          </h1>
          <p style={{ fontSize: '15px', color: 'rgba(255,255,255,0.65)', marginTop: '16px', marginBottom: 0 }}>
            Last updated: April 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <section style={{ padding: '72px 24px', backgroundColor: '#ffffff' }}>
        <div style={{ maxWidth: '860px', margin: '0 auto' }}>
          <PolicySection title="Acceptance of Terms">
            By accessing or using the Brickwell Housing website at brickwellhousing.com, you agree to be bound by these Terms of Use and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
          </PolicySection>

          <PolicySection title="Use License">
            Permission is granted to temporarily view the materials on Brickwell Housing&rsquo;s website for personal, non-commercial informational purposes only. This is the grant of a license, not a transfer of title, and under this license you may not: modify or copy the materials; use the materials for any commercial purpose; attempt to decompile or reverse engineer any software contained on the website; remove any copyright or other proprietary notations from the materials; or transfer the materials to another person.
          </PolicySection>

          <PolicySection title="Disclaimer">
            The materials on Brickwell Housing&rsquo;s website are provided on an &ldquo;as is&rdquo; basis. Brickwell Housing makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </PolicySection>

          <PolicySection title="Limitations">
            In no event shall Brickwell Housing or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Brickwell Housing&rsquo;s website, even if Brickwell Housing or an authorized representative has been notified orally or in writing of the possibility of such damage.
          </PolicySection>

          <PolicySection title="Accuracy of Materials">
            The materials appearing on Brickwell Housing&rsquo;s website could include technical, typographical, or photographic errors. Brickwell Housing does not warrant that any of the materials on its website are accurate, complete, or current. Brickwell Housing may make changes to the materials contained on its website at any time without notice.
          </PolicySection>

          <PolicySection title="Links">
            Brickwell Housing has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Brickwell Housing of the site. Use of any such linked website is at the user&rsquo;s own risk.
          </PolicySection>

          <PolicySection title="Intellectual Property">
            All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of Brickwell Housing and is protected by applicable intellectual property laws. Unauthorized use of any content may violate copyright, trademark, and other laws.
          </PolicySection>

          <PolicySection title="Governing Law">
            These terms and conditions are governed by and construed in accordance with the laws of the United States, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </PolicySection>

          <PolicySection title="Modifications">
            Brickwell Housing may revise these Terms of Use at any time without notice. By using this website, you are agreeing to be bound by the then-current version of these Terms of Use.
          </PolicySection>

          <PolicySection title="Contact Us">
            If you have any questions about these Terms of Use, please contact us at:<br /><br />
            <strong>Brickwell Housing</strong><br />
            Email: <a href="mailto:info@brickwellhousing.com" style={{ color: '#003c82', textDecoration: 'none' }}>info@brickwellhousing.com</a>
          </PolicySection>
        </div>
      </section>

      <Footer />
    </main>
  );
}

function PolicySection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: '48px' }}>
      <h2 style={{
        fontSize: '20px',
        fontWeight: '700',
        color: '#003c82',
        marginBottom: '14px',
        marginTop: 0,
        paddingBottom: '10px',
        borderBottom: '2px solid #e8f0fb',
      }}>
        {title}
      </h2>
      <p style={{ fontSize: '15px', lineHeight: '1.8', color: '#444444', margin: 0 }}>
        {children}
      </p>
    </div>
  );
}
